const LOG = "LOG";
const PATIENT = "PATIENT";
const DOCTOR = "DOCTOR";
const EMPLOYEE = "EMPLOYEE";
const USER_ROLE = "USER_ROLE";
const MESSAGE_ROOM = "MESSAGE_ROOM";
const MESSAGE = "MESSAGE";
const TREATMENT_DEMAND = "TREATMENT_DEMAND";
const ASSIGNED_TREATMENT = "ASSIGNED_TREATMENT";
const CATEGORY = "CATEGORY";
const TREATMENT_DEMAND_QUESTION = "TREATMENT_DEMAND_QUESTION";
const NOTIFICATION = "NOTIFICATION";
const NOTIFICATION_MESSAGE = "NOTIFICATION_MESSAGE";
const BOOKED_APPOINTMENT = "BOOKED_APPOINTMENT";
const TICKET_BUG_REPORT = "TICKET_BUG_REPORT";
const PAST_APPOINTMENT = `PAST_APPOINTMENT`;
const SKRS_OPERATIONS = "SKRS_OPERATIONS";
const USS_OPERATIONS = "USS_OPERATIONS";
const ASSISTANT = "ASSISTANT";
const APP_VERSION_CONFIGURATION = "APP_VERSION_CONFIG";
const SERVICE_PURCHASE = "SERVICE_PURCHASE";
const SERVICE_REFUND = "SERVICE_REFUND";

const serviceTypes = 
{
  TREATMENT_DEMAND_QUESTION,
  NOTIFICATION,
  NOTIFICATION_MESSAGE,
  LOG,
  PATIENT,
  DOCTOR,
  EMPLOYEE,
  USER_ROLE,
  TREATMENT_DEMAND,
  ASSIGNED_TREATMENT,
  MESSAGE_ROOM,
  MESSAGE,
  CATEGORY,
  BOOKED_APPOINTMENT,
  TICKET_BUG_REPORT,
  PAST_APPOINTMENT,
  SKRS_OPERATIONS,
  USS_OPERATIONS,
  ASSISTANT,
  APP_VERSION_CONFIGURATION,
  SERVICE_PURCHASE,
  SERVICE_REFUND,
};

export default serviceTypes;